<span class="go-pill-badge-container">
  <ng-content></ng-content>
  <span class="go-pill-badge" [ngClass]="badgeStyles">
    {{ badgeData | uppercase }}
  </span>
</span>
